export type MovementId =
  | 'allot'
  | 'custin'
  | 'dehire'
  | 'dehire_received'
  | 'relocation_out'
  | 'relocation_in'
  | 'transfer_out'
  | 'transfer_in';

export type WizardKind = 'standard' | 'relocation' | 'transferOut' | 'transferIn';

export type MovementConfig = {
  id: MovementId;
  title: string;
  legacyName: string;
  description: string;
  flowFrom: 'leap' | 'customer';
  flowTo: 'leap' | 'customer';
  listBacked: boolean;
  apiPath?: string;
  docType?: string;
  usesUserIdOnly?: boolean;
  wizardKind: WizardKind;
  submitPath: string;
  transferTypeKit?: string;
  transferTypeFlat?: string;
  modelType?: string;
  supportsBom?: boolean;
  fromBin?: string;
  toBay?: string;
  toBin?: string;
};

export const MOVEMENTS: MovementConfig[] = [
  {
    id: 'allot',
    title: 'LEAP to Customer',
    legacyName: 'Allot',
    description: 'Outbound from LEAP warehouse to customer',
    flowFrom: 'leap',
    flowTo: 'customer',
    listBacked: true,
    apiPath: '/allot',
    docType: 'ALLOT',
    wizardKind: 'standard',
    submitPath: '/post_leap_out',
    transferTypeKit: 'LEAPOUTAUT',
    transferTypeFlat: 'LEAPOUT',
    modelType: '102',
    supportsBom: true,
    fromBin: 'CONDITION',
  },
  {
    id: 'custin',
    title: 'Inward at Customer location',
    legacyName: 'Custin',
    description: 'Receive inventory at customer site',
    flowFrom: 'customer',
    flowTo: 'customer',
    listBacked: true,
    apiPath: '/custin',
    docType: 'CUSTIN',
    wizardKind: 'standard',
    submitPath: '/post_leap_in',
    transferTypeKit: 'CUSTINAUT',
    transferTypeFlat: 'CUSTIN',
    modelType: '113',
    fromBin: 'CUSTMAIN',
    toBin: 'CUSTIN',
  },
  {
    id: 'dehire',
    title: 'Dehire outward from Customer',
    legacyName: 'Dehire',
    description: 'Customer outbound dehire documents',
    flowFrom: 'customer',
    flowTo: 'customer',
    listBacked: true,
    apiPath: '/dehire',
    docType: 'DEHIRE',
    wizardKind: 'standard',
    submitPath: '/post_cust_out',
    transferTypeKit: 'CUSTOUTAUT',
    transferTypeFlat: 'CUSTOUT',
    modelType: '113',
    fromBin: 'CUSTMAIN',
    toBay: 'B001',
    toBin: 'DEHIRE',
  },
  {
    id: 'dehire_received',
    title: 'Dehire inward to LEAP',
    legacyName: 'Dehire Received',
    description: 'Return flow into LEAP warehouse',
    flowFrom: 'customer',
    flowTo: 'leap',
    listBacked: true,
    apiPath: '/cust_out_docs',
    usesUserIdOnly: true,
    wizardKind: 'standard',
    submitPath: '/post_leap_in',
    transferTypeKit: 'LEAPINAUTO',
    transferTypeFlat: 'LEAPIN',
    modelType: '113',
    fromBin: 'DEHIRE',
    toBin: 'SORTING',
  },
  {
    id: 'relocation_out',
    title: 'Relocation out',
    legacyName: 'Relocation Out',
    description: 'Move stock out to another warehouse',
    flowFrom: 'leap',
    flowTo: 'leap',
    listBacked: true,
    fromBin: 'REPAIR',
    apiPath: '/FetchRelocation',
    docType: 'ZREL',
    wizardKind: 'relocation',
    submitPath: '/POSTRelocationOut',
    transferTypeFlat: 'REL_OUT',
    modelType: '111',
  },
  {
    id: 'relocation_in',
    title: 'Relocation in',
    legacyName: 'Relocation In',
    description: 'Receive from another LEAP warehouse',
    flowFrom: 'leap',
    flowTo: 'leap',
    listBacked: true,
    fromBin: 'REPAIR',
    apiPath: '/Fetch_RelOut_Docs',
    usesUserIdOnly: true,
    wizardKind: 'relocation',
    submitPath: '/POSTRelocationIn',
    transferTypeFlat: 'REL_IN',
    modelType: '111',
  },
  {
    id: 'transfer_out',
    title: 'Transfer out',
    legacyName: 'Transfer Out',
    description: 'Customer-to-customer movement (outbound)',
    flowFrom: 'customer',
    flowTo: 'customer',
    listBacked: false,
    wizardKind: 'transferOut',
    submitPath: '/Transout',
    transferTypeKit: 'TROUT_AUTO',
    transferTypeFlat: 'TROUT',
    modelType: '113',
  },
  {
    id: 'transfer_in',
    title: 'Transfer in',
    legacyName: 'Transfer In',
    description: 'Customer-to-customer movement (inbound)',
    flowFrom: 'customer',
    flowTo: 'customer',
    listBacked: false,
    wizardKind: 'transferIn',
    submitPath: '/Post_TransferIn',
    transferTypeKit: 'TRIN_AUTO',
    transferTypeFlat: 'TRIN',
    modelType: '113',
  },
];

export function getMovement(id: MovementId): MovementConfig {
  const m = MOVEMENTS.find((x) => x.id === id);
  if (!m) throw new Error(`Unknown movement: ${id}`);
  return m;
}

